import ApplicationController from './application_controller';
import Cookies from 'js-cookie';
import { isEmpty } from '../vendor/helpers';

export default class extends ApplicationController {
  static targets = []
  static values = {
    loggedIn: false
  }

  connect() {
    if (this.loggedInValue || typeof currentuserData !== 'undefined') return;

    const utmParams = this.getUTMParameters();
    if (!isEmpty(utmParams)) {
      Cookies.set('utm_params_session', JSON.stringify(utmParams));
    }
  }

  getUTMParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
      const value = urlParams.get(param);
      if (value) utmParams[param] = value;
    });
    return utmParams;
  }
}